import {useEffect} from "react";
import {useQuery} from "react-query";
import {Box} from "@mui/system";
import {Tab, Tabs} from "@mui/material";
import Grid from "@mui/material/Grid2";


import {getQueryData, getVendorListURL, withCredentials} from "../../services";
import {BackdropComponent} from "../../components";

import {EducationHubInfoCard, HomeFooterCard, AIToolsInfoCard, HomeBanner} from "./components";
import {tabStyles} from "./home.helper";

export const Home = () => {

    const {data: vendorsData, isLoading: isVendorsLoading} = useQuery("vendorListData", async () =>
        getQueryData(getVendorListURL, withCredentials())
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <HomeBanner/>

            <Grid container spacing={2} sx={{display: "flex", flexGrow: 0}}>
                <Grid size={{xs: 12, md: 6}} sx={tabStyles.tabContainer}>
                    <Tabs value={0} variant="fullWidth"
                          slotProps={{
                              indicator: {
                                  sx: {
                                      display: 'none',
                                  },
                              },
                          }}>
                        <Tab label="Education Hub"
                             disableRipple={true}
                             sx={{...tabStyles.tab, ...tabStyles.educationHubTab, color: "white"}}/>
                    </Tabs>
                    <EducationHubInfoCard/>
                </Grid>

                <Grid size={{xs: 12, md: 6}} sx={tabStyles.tabContainer}>
                    <Tabs value={0} variant="fullWidth"
                          slotProps={{
                              indicator: {
                                  sx: {
                                      display: 'none',
                                  },
                              },
                          }}>
                        <Tab label="AI Tools"
                             disableRipple={true}
                             sx={{...tabStyles.tab, ...tabStyles.aiToolsTab}}/>
                    </Tabs>
                    <AIToolsInfoCard data={vendorsData?.data}/>
                </Grid>
            </Grid>

            <Box sx={{display: 'flex', flexDirection: 'column'}}>
                <BackdropComponent showBackdrop={isVendorsLoading}/>
                <HomeFooterCard/>
            </Box>
        </>
    )
}